import { useTranslation } from 'react-i18next'
import Follow from '../components/Follow'
import { Donate, type DonateOrg } from '../components/Donate'
import { ResourceGroups } from '../components/ResourceGroups'
import { DownloadGraphics } from '../components/DownloadGraphics'
import { artPosters } from '../assets/posters/oct-2026'
import { oleshkySources } from '../data/follow'
import { oleshkyResources } from '../data/oleshkyResources'
import { fellas4europe } from '../data/donateOrgs'
import { oleshkyPetitions } from '../data/petitions'
import { Link } from 'react-router'
import { routes } from '../routes'

import krylaImg from 'url:../assets/kryla.png'
import webIcon from 'url:../assets/web.png'
import instagramIcon from 'url:../assets/instagram.png'
import facebookIcon from 'url:../assets/facebook.png'
import blueskyIcon from 'url:../assets/bluesky.png'
import xIcon from 'url:../assets/x.png'

const shareLinks = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=https://humansafari.org',
  x: 'https://twitter.com/intent/tweet?text=%23StopDroneSiege%20Russian%20drones%20besiege%206%2C000%20civilians%20in%20Oleshky.%20This%20war%20crime%20must%20stop%3A%20https%3A%2F%2Fhumansafari.org%20%23HumansAreNotTargets%20%23SaveOleshky%20%23SafePassageNow',
  bluesky:
    'https://bsky.app/intent/compose?text=%23StopDroneSiege%20Russian%20drones%20besiege%206%2C000%20civilians%20in%20Oleshky.%20This%20war%20crime%20must%20stop%3A%20https%3A%2F%2Fhumansafari.org%20%23HumansAreNotTargets%20%23SaveOleshky%20%23SafePassageNow',
}

const orgs: DonateOrg[] = [
  {
    key: 'kryla',
    img: krylaImg,
    donateUrl: 'https://www.kryla.foundation/#donate',
    socialLinks: [
      { asset: webIcon, labelKey: 'help.website', href: 'https://www.kryla.foundation/' },
      { asset: facebookIcon, labelKey: 'help.facebook', href: 'https://www.facebook.com/KRYLA.CF' },
      {
        asset: instagramIcon,
        labelKey: 'help.instagram',
        href: 'https://www.instagram.com/kryla_cf',
      },
    ],
  },
  // food relief: donors write "Food for Cherson" as the reference
  { ...fellas4europe, descKey: 'help.fellas.foodDesc', noteKey: 'help.fellas.foodNote' },
]

export default function LeftBank() {
  const { t } = useTranslation()

  return (
    <div className='w-full text-gray-900 flex flex-col text-lg'>
      <section className='px-6 md:px-20 py-16 bg-gray-100 flex flex-col items-center gap-16'>
        <div className='text-center max-w-2xl flex flex-col gap-8'>
          <h1 className='text-4xl md:text-5xl font-bold'>{t('leftBank.pageTitle')}</h1>
          <p className='text-lg opacity-70'>{t('leftBank.para1')}</p>
          <p className='text-lg opacity-70'>
            {t('leftBank.para2')} <strong>{t('leftBank.callToHelp')}</strong>
          </p>
        </div>

        {/* Tell people */}
        <div className='flex flex-col gap-6 w-full max-w-5xl'>
          <h2 className='text-2xl font-bold'>{t('help.step3Title')}</h2>
          <p className='opacity-80'>
            {t('help.step3Para')} <strong>#StopDroneSiege #SaveOleshky #SafePassageNow</strong>{' '}
            {t('leftBank.tellPost')}
          </p>
          <p className='font-semibold'>{t('help.shareTitle')}</p>
          <div className='flex gap-4 flex-col md:flex-row'>
            <a
              href={shareLinks.facebook}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2'
            >
              {t('help.share', { platform: '' })}{' '}
              <img src={facebookIcon} alt={t('help.facebook')} className='h-5 w-5' />
            </a>
            <a
              href={shareLinks.x}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2'
            >
              {t('help.share', { platform: '' })}{' '}
              <img src={xIcon} alt={t('help.x')} className='h-5 w-5' />
            </a>
            <a
              href={shareLinks.bluesky}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-800 border-blue-700 border-2 px-4 py-2 rounded-md flex items-center gap-2'
            >
              {t('help.share', { platform: '' })}{' '}
              <img src={blueskyIcon} alt={t('help.bluesky')} className='h-5 w-5' />
            </a>
          </div>
          <p className='opacity-60'>#StopDroneSiege #SaveOleshky #SafePassageNow</p>
        </div>

        {/* Organise */}
        <div className='flex flex-col gap-4 w-full max-w-5xl'>
          <h2 className='text-2xl font-bold'>{t('help.step2Title')}</h2>
          <ul className='list-disc ml-6 flex flex-col gap-4'>
            <li>
              <span className='font-medium'>{t('help.step2Bullet2')}</span>
              <p className='mt-1 opacity-80'>
                {t('leftBank.publicActionLead')}{' '}
                <Link to={routes.oleshky.path} className='text-blue-700 underline'>
                  {t('leftBank.organiseAction')}
                </Link>{' '}
                {t('help.reachOutPre')}{' '}
                <a className='text-blue-700 underline' href={`mailto:${t('help.actionEmail')}`}>
                  {t('help.reachOut')}
                </a>{' '}
                {t('help.reachOutPost')}
              </p>
            </li>
          </ul>
        </div>

        <Donate orgs={orgs} introKey='leftBank.donateIntro' />

        {/* Policy */}
        <div className='flex flex-col gap-6 w-full max-w-5xl'>
          <h2 className='text-2xl font-bold'>{t('help.policyTitle')}</h2>
          <p className='opacity-80'>{t('leftBank.policyBody')}</p>
          <p className='opacity-80'>
            {t('help.policyHelp')}{' '}
            <a href={`mailto:${t('help.actionEmail')}`} className='text-blue-600 underline'>
              {t('help.getInTouch')} →
            </a>
          </p>
        </div>

        {/* Sign: petitions */}
        <div className='flex flex-col gap-6 w-full max-w-5xl'>
          <div className='flex flex-col gap-3'>
            <h2 className='text-2xl font-bold'>{t('leftBank.signTitle')}</h2>
            <p className='opacity-70'>{t('leftBank.signSub')}</p>
          </div>
          <ul className='list-disc ml-6 flex flex-col gap-2'>
            {oleshkyPetitions.map(({ titleKey, href, by }) => (
              <li key={href}>
                <a
                  href={href}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-600 underline'
                >
                  {t(titleKey)}
                </a>
                {by && ` – ${t('leftBank.petitionBy', { name: by })}`}
              </li>
            ))}
          </ul>
        </div>

        <Follow groups={oleshkySources} subKey='follow.subDroneSiege' />

        {/* Inform */}
        <div className='flex flex-col gap-6 w-full max-w-5xl'>
          <div className='flex flex-col gap-3'>
            <h2 className='text-2xl font-bold'>{t('help.inform')}</h2>
            <p className='opacity-70'>{t('help.informSub')}</p>
          </div>
          <div className='flex flex-col gap-6'>
            <ResourceGroups groups={oleshkyResources} />
          </div>
        </div>

        {/* Download: posters by named artists */}
        <DownloadGraphics id='art-posters' images={artPosters} />
      </section>

      {/* How it started */}
      <section className='flex justify-center items-center py-12 bg-white'>
        <Link to={routes.action.path} className='text-blue-700 underline text-xl'>
          {t('help.howItStarted')} →
        </Link>
      </section>
    </div>
  )
}
